import React from 'react';

/**
 * リリース情報
 */
export default function MusicAlbumInfoReleaseTrackIsrcView({
  musicAlbum,
  music,
} : {
  musicAlbum: {
    release_status: number,
  },
  music: {
    id: number,
    is_inst: number,
    tunecore_release_track?: {
      isrc: string|null,
    },
  },
}) {
  // 作成中や要修正の場合は表示しない
  if (musicAlbum.release_status === 0 || musicAlbum.release_status === 5) {
    return null;
  }
  // ISRCがない場合は表示しない
  if (!music.tunecore_release_track || !music.tunecore_release_track.isrc) {
    return null;
  }

  return (
    <>
      <ul className="song_details">
        <li>
          <span>ISRC：</span>
          {music.tunecore_release_track.isrc}
        </li>
      </ul>
    </>
  );
}
